import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";

import { cn } from "@/shared/lib/css";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/shared/ui/kit/tooltip";

interface InfoTooltipProps {
  /** i18n key whose value is shown inside the tooltip body. */
  tKey: string;
  /** Tooltip side relative to the trigger. Defaults to Radix default ("top"). */
  side?: "top" | "right" | "bottom" | "left";
  /** Additional className applied to the trigger button. */
  className?: string;
}

export function InfoTooltip({ tKey, side, className }: InfoTooltipProps) {
  const { t } = useTranslation();
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label={t("common.moreInfo")}
          // Stop propagation so clicking the icon inside a wrapping <Link>
          // or row-button doesn't navigate / submit. preventDefault is
          // needed in addition because React's synthetic <a> handlers fire
          // on the bubble phase too.
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
          }}
          className={cn(
            "inline-flex items-center text-muted-foreground hover:text-foreground transition-colors",
            className,
          )}
        >
          <Info className="size-3.5" />
        </button>
      </TooltipTrigger>
      <TooltipContent side={side} className="max-w-xs text-sm">
        {t(tKey)}
      </TooltipContent>
    </Tooltip>
  );
}
